export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHx3YXJlaG91c2UlMjBsb2dpc3RpY3MlMjBwcm9kdWN0c3xlbnwwfHx8fDE3OTIwMjgyNTR8MA&ixlib=rb-4.1.0&q=85",
    caseBeverage: "https://images.unsplash.com/photo-1530037335614-e68828dcf258?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxiZXZlcmFnZSUyMG1hbnVmYWN0dXJpbmclMjBwYWNrYWdpbmd8ZW58MHx8fHwxNzkyMDI4MjU0fDA&ixlib=rb-4.1.0&q=85",
    caseDistribution: "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHx3YXJlaG91c2UlMjBsb2dpc3RpY3MlMjBwcm9kdWN0c3xlbnwwfHx8fDE3OTIwMjgyNTR8MA&ixlib=rb-4.1.0&q=85",
    casePackaging: "https://images.unsplash.com/photo-1571250315503-ecb14720ad5d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHw0fHxiZXZlcmFnZSUyMG1hbnVmYWN0dXJpbmclMjBwYWNrYWdpbmd8ZW58MHx8fHwxNzkyMDI4MjU0fDA&ixlib=rb-4.1.0&q=85",
    founder: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGZvdW5kZXIlMjBwb3J0cmFpdHxlbnwwfHx8fDE3OTIwMjgyNTR8MA&ixlib=rb-4.1.0&q=85",
    roma: "https://images.unsplash.com/photo-1639696194673-67b86204b885?auto=format&fit=crop&w=1400&q=80",
    marketEntry: "https://images.unsplash.com/photo-1684695749267-233af13276d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHw0fHx3YXJlaG91c2UlMjBsb2dpc3RpY3MlMjBwcm9kdWN0c3xlbnwwfHx8fDE3OTIwMjgyNTR8MA&ixlib=rb-4.1.0&q=85",
};

export const MARQUEE_ITEMS = [
    "RETAIL · WHOLESALE · DISTRIBUTION", "PRICING & GROSS MARGIN", "SALES & CHANNEL GROWTH",
    "NZ MARKET ENTRY", "EXECUTION & ACCOUNTABILITY",
];

export const WHO_WE_HELP =
    "Established NZ product businesses — retailers, wholesalers, importers, distributors and consumer brands. Other established SMEs are welcome to enquire if the challenges fit.";

export const WHO_CHIPS = ["Retailers", "Wholesalers", "Importers", "Distributors", "Consumer Brands"];

export const PAINS = [
    "Sales are growing, but profit isn't improving.",
    "Margin erosion across key products and customers.",
    "Poor product or customer mix dragging down returns.",
    "Missed channels and market opportunities.",
    "Stock and cash tied up in the wrong places.",
    "Too many priorities — and too little execution.",
];

export const THREE_PILLARS = [
    { id: "grow-sales", title: "Grow Sales", tag: "Customers & channels", desc: "Win more of the right customers through the right channels — with a pipeline and follow-up rhythm that actually runs." },
    { id: "improve-profit", title: "Improve Profit", tag: "Pricing, margins & product mix", desc: "Sharper pricing, disciplined discounting and a better product and customer mix — so growth shows up in the margin, not just the revenue line." },
    { id: "execute-better", title: "Execute Better", tag: "Priorities, systems & accountability", desc: "A small number of clear priorities, simple systems and real accountability — so the plan gets done, week after week." },
];

export const PILLARS = [
    { id: "revenue", label: "Sales & Customers", desc: "Sales growth, customer concentration, pipeline, conversion, account development and repeat business." },
    { id: "margin", label: "Margins & Pricing", desc: "Pricing, discounts, promotions, gross margin, product mix, landed costs and profitability." },
    { id: "channels", label: "Channels & Distribution", desc: "Retail, wholesale, ecommerce, distribution, export and market-entry opportunities — and channel fit." },
    { id: "operations", label: "Operations & Delivery", desc: "Inventory, supply chain, processes, systems, stock exposure and execution capacity." },
    { id: "people", label: "Team & Accountability", desc: "Roles, capability, management quality, accountability, succession and owner dependency." },
    { id: "execution", label: "Priorities & Follow-Through", desc: "KPIs, priorities, meetings, action ownership, deadlines and follow-through." },
];

export const HOW_WE_WORK = [
    { step: "01", title: "Free Growth Conversation", desc: "A practical 30-minute discussion about where the business is constrained and what to tackle first. No obligation.", tag: "Free" },
    { step: "02", title: "Commercial Growth Diagnostic", desc: "A focused review of sales, margins, pricing, channels and execution, ending in a prioritised action plan.", tag: "From $1,500 + GST" },
    { step: "03", title: "Advisory Retainer or Implementation Project", desc: "Ongoing advice and accountability each month, or a defined hands-on project to deliver a specific result. Or both.", tag: "Scoped to fit" },
];

// The two core services. Everything else (Diagnostic, GrowVise 90, Market Entry) is a format of one of these.
export const SERVICES = [
    {
        id: "advisory-retainer",
        title: "Advisory Retainer",
        badge: "Ongoing Support",
        investment: "From $2,000 + GST / month",
        timeframe: "Monthly, scope and term agreed upfront",
        who: "For owners who want a senior commercial advisor in their corner every month, without hiring a full-time GM or commercial manager.",
        includes: [
            "Monthly commercial performance review: sales, margin, stock and cash",
            "Pricing, discount and promotion decisions reviewed before they cost you",
            "A short list of agreed priorities, each with an owner and a deadline",
            "Regular accountability check-ins with you and your key people",
            "Direct access to Leo between sessions for commercial calls",
        ],
        cta: "Discuss a Retainer",
        href: "/book-a-conversation",
    },
    {
        id: "implementation-projects",
        title: "Implementation Projects",
        badge: "Hands-On Delivery",
        featured: true,
        investment: "From $1,500 + GST, quoted to scope",
        timeframe: "Defined deliverables, fixed timeframe",
        who: "For businesses with a specific commercial problem to fix, where we work alongside your team to get it done, not just recommend it.",
        includes: [
            "Commercial Growth Diagnostic: the starting point, from $1,500 + GST",
            "GrowVise 90: a 90-day growth and execution programme, from $6,000 + GST",
            "Pricing, margin and product or customer mix projects",
            "Sales, channel and distributor development",
            "NZ Market Entry for brands launching here, by custom proposal",
        ],
        cta: "Request a Proposal",
        href: "/book-a-conversation",
    },
];
export const OFFERS = SERVICES;

export const MARKET_ENTRY_OFFER = {
    title: "NZ Market Entry",
    investment: "Custom proposal",
    summary: "Feasibility, channel strategy, wholesale and distribution pricing, and go-to-market support for brands expanding in New Zealand.",
    cta: "Discuss NZ Market Entry",
    href: "/market-entry-distribution",
};

export const HEALTH_QUESTIONS = [
    { id: "hc-1", category: "revenue", text: "We know which customers and products are driving our sales." },
    { id: "hc-2", category: "margin", text: "We understand our gross margins and price discounts across key products or services." },
    { id: "hc-3", category: "channels", text: "We have a clear plan for the sales channels and customers we want to develop." },
    { id: "hc-4", category: "operations", text: "Our operations and stock/process systems allow us to deliver reliably." },
    { id: "hc-5", category: "people", text: "Responsibilities and accountability are clear across our team." },
    { id: "hc-6", category: "execution", text: "Our top three business priorities have an owner, deadline and regular follow-up." },
];

export const HC_AREA_LABELS = {
    revenue: "Sales & customers",
    margin: "Margins & pricing",
    channels: "Channels & distribution",
    operations: "Operations & delivery",
    people: "Team & accountability",
    execution: "Priorities & follow-through",
};

export const LIKERT = [
    { value: 1, label: "Strongly disagree" },
    { value: 2, label: "Disagree" },
    { value: 3, label: "Neutral" },
    { value: 4, label: "Agree" },
    { value: 5, label: "Strongly agree" },
];

// Results page switch. Keep false until every figure below is verified and approved,
// then set true: the page, nav link, footer link and sitemap entry all come back.
export const SHOW_RESULTS = true;

// Founder details for the About page. Fill in and redeploy.
// photo: put the headshot in public/images/ (e.g. "/images/leo.jpg"). Leave "" to show the logo panel.
export const FOUNDER = {
    name: "Leo",            // full name, e.g. "Leo Surname"
    role: "Founder & Commercial Director",
    photo: "",
    linkedin: "",           // e.g. "https://www.linkedin.com/in/..."
};

export const CASE_STUDIES = [
    {
        slug: "jnx-sports",
        client: "JNX Sports",
        kind: "Commercial experience case study",
        title: "Building a Strong Nationwide Brand in a Competitive Market",
        cardSummary: "How accessible pricing, value-added promotions, brand-owner support and nationwide distribution keep JNX Sports performing in a crowded pre-workout category.",
        meta: [
            { label: "Industry", value: "Sports Nutrition" },
            { label: "Market", value: "New Zealand" },
            { label: "Capabilities", value: "Brand Development · Pricing Strategy · Retail Distribution · Supplier Partnerships" },
        ],
        intro: {
            heading: "Introduction",
            paragraphs: [
                "JNX Sports is an international sports nutrition brand whose New Zealand market presence has been supported through Sky Nutrition. Its experience shows how accessible pricing, value-added promotions, committed brand owners and consistent distribution can support a brand in a changing category.",
            ],
        },
        highlights: {
            heading: "What Made the Difference",
            items: [
                { icon: "tag", title: "Competitive Pricing", desc: "Accessible pricing in a competitive category." },
                { icon: "gift", title: "Value-Added Promotions", desc: "Complimentary JNX skull shaker with The Curse! pre-workout." },
                { icon: "handshake", title: "Brand Owner Support", desc: "Strong manufacturer–distributor collaboration." },
                { icon: "map", title: "Nationwide Distribution", desc: "Established retail presence across New Zealand." },
            ],
        },
        sections: [
            {
                heading: "The Challenge",
                paragraphs: [
                    "The New Zealand sports nutrition market is highly competitive. Growing consumer interest in ready-to-drink (RTD) pre-workout and energy products has created additional competition for traditional powdered pre-workouts. In this environment, brands need to remain relevant, offer clear value and retain the confidence of retail partners.",
                ],
            },
            {
                heading: "The Commercial Strategy",
                steps: [
                    { title: "Competitive, accessible pricing", text: "Positioning JNX products at a relatively affordable price point compared with many competing pre-workouts, supporting a strong value proposition for consumers and retailers." },
                    { title: "Value-added promotions", text: "Using offers such as a complimentary JNX skull shaker with The Curse! to provide a tangible consumer benefit and give retailers a clear promotional message." },
                    { title: "Committed brand-owner partnership", text: "Working with supportive brand owners to align market needs, promotions and commercial activity. This manufacturer–distributor relationship has been an important factor in sustaining the brand's position." },
                    { title: "Nationwide retail relationships", text: "Maintaining availability across New Zealand through specialist retail relationships, account management and distribution support." },
                    { title: "Consistent execution", text: "Supporting the brand through ongoing promotional planning, customer communication, supply coordination and market responsiveness." },
                ],
            },
            {
                heading: "The Outcome",
                paragraphs: [
                    "JNX Sports continues to perform strongly in New Zealand despite competitive pressure in the traditional pre-workout category. The brand has a prominent nationwide retail presence and is well regarded within the sports nutrition market. Its continued performance reflects the combined importance of pricing, promotional value, retailer relationships and brand-owner support.",
                ],
            },
        ],
        lesson: "A strong product alone is not enough. Sustained market presence depends on the commercial system around it: the right price, relevant promotions, reliable distribution, aligned suppliers and consistent execution.",
        connection: "GrowVise draws on this practical operating experience to help product-based businesses strengthen market positioning, improve pricing decisions, build distribution channels and implement commercially effective growth initiatives.",
        disclosure: "This case study describes commercial experience through Sky Nutrition. JNX Sports is not represented as a GrowVise consulting client.",
        seo: {
            title: "JNX Sports NZ Case Study: Building a Nationwide Brand | GrowVise",
            description: "How pricing, value-added promotions, brand-owner support and nationwide distribution keep JNX Sports strong in New Zealand's competitive pre-workout category.",
        },
    },
    {
        slug: "atp-science",
        client: "ATP Science",
        kind: "Commercial experience case study",
        title: "Building a Multi-Channel Distribution Strategy in New Zealand",
        cardSummary: "Market Development & Channel Expansion: building a coordinated route to market across specialist retail, wellness and selected grocery channels.",
        meta: [
            { label: "Industry", value: "Health, Wellness & Sports Nutrition" },
            { label: "Market", value: "New Zealand" },
            { label: "Expertise", value: "Market Development · Channel Expansion · Retail Networks · Distribution Execution" },
        ],
        intro: {
            heading: "The Opportunity",
            paragraphs: [
                "ATP Science had an existing presence in New Zealand and had previously worked with other distributors. The opportunity was not simply to introduce the brand to the market, but to develop a more coordinated distribution model that could connect products, retail relationships, market knowledge, stock availability and promotional support.",
                "Sky Nutrition brought an established network of retail relationships, a customer database and local distribution capabilities. The aim is to bring these elements together so ATP Science can develop into a stronger, more widely accessible brand in New Zealand.",
            ],
        },
        highlights: {
            heading: "What Makes the Approach Different",
            items: [
                { icon: "network", title: "Established Retail Network", desc: "Using existing Sky Nutrition relationships and customer reach to accelerate relevant introductions." },
                { icon: "store", title: "Beyond Specialist Stores", desc: "Targeting pharmacies, health food stores and selected independent grocery outlets alongside supplement retailers." },
                { icon: "layers", title: "Joined-Up Execution", desc: "Aligning product selection, channel positioning, stock, promotions and account management." },
                { icon: "sprout", title: "Long-Term Brand Building", desc: "Developing sustainable retail partnerships rather than relying on isolated product placements." },
            ],
        },
        sections: [
            {
                heading: "The Commercial Challenge",
                paragraphs: [
                    "A brand can have products available in a market without having a fully coordinated route to customers. Effective distribution depends on the right retailers, appropriate product positioning, reliable fulfilment, clear trade offers and consistent follow-through. Those pieces need to work together.",
                ],
            },
            {
                heading: "The Commercial Approach",
                steps: [
                    { title: "Activating an established network", text: "Using Sky Nutrition's existing retailer relationships and customer database to identify suitable opportunities and build conversations with buyers." },
                    { title: "Expanding into complementary channels", text: "Alongside specialist supplement stores, exploring pharmacies, health food retailers and independent grocery operators, including formats such as Bin Inn and FreshChoice where product fit and buyer interest support an opportunity." },
                    { title: "Matching products to each retail environment", text: "Recognising that the same product story does not work everywhere. Products such as Noway Collagen Protein Water can be positioned differently for wellness-focused customers than for traditional sports nutrition shoppers." },
                    { title: "Coordinating the commercial fundamentals", text: "Bringing together retail pricing, introductory offers, sampling, marketing support, local stock availability, account management and delivery so the channel strategy can be executed consistently." },
                    { title: "Building through collaboration", text: "Working with the brand and retail partners to refine the approach, learn from early market feedback and support sustainable growth." },
                ],
            },
            {
                heading: "Progress and Outlook",
                paragraphs: [
                    "The Sky Nutrition-led market development approach is still relatively new. Early progress and the breadth of potential retail channels are encouraging, but the expansion remains a work in progress. It would be premature to present projected growth or future listings as achieved results.",
                    "The opportunity is promising because the strategy is designed around a coordinated distribution system, rather than treating each retailer introduction as a stand-alone sale.",
                ],
            },
        ],
        lesson: "Successful distribution is not just about having products in the country. It is about making the network, data, retail channels, product positioning, supplier support and day-to-day execution work together.",
        connection: "This experience informs GrowVise's practical approach to helping product-based businesses strengthen routes to market, open relevant sales channels and turn commercial plans into coordinated action.",
        disclosure: "This case study describes commercial market-development work undertaken through Sky Nutrition. It is not presented as a GrowVise client engagement. The initiative is ongoing; prospective retailer channels are not claims of confirmed listings.",
        seo: {
            title: "ATP Science NZ Market Development Case Study | GrowVise",
            description: "Discover how commercial experience through Sky Nutrition is supporting ATP Science's multi-channel market development in New Zealand.",
        },
    },
    {
        slug: "roma-blooms",
        client: "Roma Blooms",
        kind: "Client case study",
        title: "Growing Online Revenue for a Local Florist",
        cardSummary: "Florist & Gifts: tiered ranging, checkout add-ons, sharper Google Ads and pre-order peak days to lift online revenue and protect margin.",
        image: "roma",
        logo: "/images/roma-blooms-logo.png",
        alt: "Florist shop interior with fresh flowers, Roma Blooms logo",
        meta: [
            { label: "Industry", value: "Florist & Gifts" },
            { label: "Market", value: "New Zealand" },
            { label: "Channels", value: "Retail · Online" },
        ],
        intro: {
            heading: "The Problem",
            paragraphs: [
                "A well-loved florist with strong walk-in trade, but online orders were flat, average order value was low and paid ads were spending without clear returns. Peak days like Valentine's and Mother's Day were capacity-constrained and margin was leaking through rushed discounting.",
            ],
        },
        sections: [
            {
                heading: "What GrowVise Did",
                steps: [
                    { title: "Tiered range", text: "Rebuilt the product range around three price tiers and retired low-margin SKUs." },
                    { title: "Checkout add-ons", text: "Added gift add-ons (vases, chocolates, cards) at checkout to lift basket size." },
                    { title: "Smarter Google Ads", text: "Restructured Google Ads around high-intent local searches and peak-day calendars." },
                    { title: "Peak-day pre-orders", text: "Introduced pre-order windows for peak days to smooth workload and protect margin." },
                ],
            },
            {
                heading: "The Result",
                paragraphs: [
                    "Online revenue up 64% in six months, average order value up 23%, and return on ad spend lifted from 2.1x to 5.4x. Peak days now sell out on pre-orders at full price.",
                ],
            },
        ],
        metrics: [
            { label: "Online revenue", value: "+64%" },
            { label: "Avg order value", value: "+23%" },
            { label: "Return on ad spend", value: "2.1x → 5.4x" },
        ],
        seo: {
            title: "Roma Blooms Case Study: Growing Online Revenue | GrowVise",
            description: "How a NZ florist lifted online revenue, order value and ad returns with tiered ranging, checkout add-ons and peak-day pre-orders.",
        },
    },
];


export const STATS = [
    { value: "16+", label: "Years' Founder Commercial Experience" },
    { value: "20+", label: "Global Brands Distributed in NZ" },
    { value: "Retail · Wholesale · Distribution", label: "Specialist Focus" },
    { value: "NZ", label: "Market Specialist" },
];

export const CHALLENGE_OPTIONS = [
    "Sales are growing but profit isn't",
    "Margin erosion / rising costs",
    "Missed channels or market opportunities",
    "Stock and cash tied up",
    "Too many priorities, too little execution",
    "Owner dependency — everything runs through me",
];

export const INDUSTRY_OPTIONS = ["Retail", "Wholesale", "Import / Distribution", "Consumer brand / FMCG", "Manufacturing", "Other established SME"];
export const TURNOVER_OPTIONS = ["Under $1M", "$1M – $3M", "$3M – $6M", "$6M – $10M", "$10M+", "Prefer not to say"];
export const HELP_OPTIONS = ["Pricing & margins", "Sales & channel development", "Operations & execution", "NZ market entry", "A full commercial review", "Not sure yet"];
